import { render, staticRenderFns } from "./RelacaoCancelamentoEntregasFiltros.vue?vue&type=template&id=d5458cf2"
import script from "./RelacaoCancelamentoEntregasFiltros.vue?vue&type=script&lang=js"
export * from "./RelacaoCancelamentoEntregasFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports